export function canPerformHeadActions(session: {
  role?: string
  authority?: string
}): boolean {
  if (session.role === 'HEAD_KITCHEN') return true
  if (session.role === 'ASSISTANT_HEAD_KITCHEN') return session.authority === 'full'
  return false
}
